import { render, staticRenderFns } from "./NiubizForm.vue?vue&type=template&id=3b3e1d12&scoped=true&"
import script from "./NiubizForm.vue?vue&type=script&lang=js&"
export * from "./NiubizForm.vue?vue&type=script&lang=js&"
import style0 from "./NiubizForm.vue?vue&type=style&index=0&id=3b3e1d12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3e1d12",
  null
  
)

export default component.exports